import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const WALLET_SHOW_VALUES_KEY = 'wallet_show_values';

export interface WalletActionInitialValuesTypes {
  showValues: boolean;
  unit: 'TMN' | 'USDT';
}

const getShowValuesFromStorage = (): boolean => {
  try {
    const stored = localStorage.getItem(WALLET_SHOW_VALUES_KEY);
    return stored ? JSON.parse(stored) : true; // Default to true
  } catch {
    return true;
  }
};

const WALLET_UNIT_KEY = 'wallet_unit';

const getUnitFromStorage = (): 'TMN' | 'USDT' => {
  try {
    const stored = localStorage.getItem(WALLET_UNIT_KEY);
    const unit = stored ? JSON.parse(stored) : 'TMN';
    // Anything else (an old or hand-edited value) falls back to toman
    return unit === 'USDT' ? 'USDT' : 'TMN';
  } catch {
    return 'TMN';
  }
};

const initialState: WalletActionInitialValuesTypes = {
  showValues: getShowValuesFromStorage(),
  unit: getUnitFromStorage()
};

const wallet = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    toggleShowValues: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.showValues = !state.showValues;
      localStorage.setItem(
        WALLET_SHOW_VALUES_KEY,
        JSON.stringify(state.showValues)
      );
    },
    toggleUnit: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.unit = action.payload;
      try {
        localStorage.setItem(WALLET_UNIT_KEY, JSON.stringify(state.unit));
      } catch {
        // Private mode / blocked storage: the unit just is not remembered.
      }
    }
  }
});

// Action creators are generated for each case reducer function
export const { toggleShowValues, toggleUnit } = wallet.actions;

export default wallet.reducer;
